import React from "react";

function SearchBox({ value, onChange, placeholder }) {
  return (
    <div style={styles.container}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={styles.input}
      />
    </div>
  );
}

const styles = {
  container: {
    paddingBottom: 20,
  },
  input: {
    background: "#111",
    border: "1px solid #444",
    borderRadius: 6,
    padding: "10px 12px",
    width: "100%",
    maxWidth: 400,
    color: "#ccc",
    fontSize: 14,
    lineHeight: 1.2,
    fontWeight: 400,
    fontFamily: '"Segoe UI", sans-serif',
  },
};
export default SearchBox;
